const isLocalhost = Boolean(
  window.location.hostname === 'localhost' ||
    window.location.hostname === '[::1]' ||
    window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

export function register(config) {
  const inProduction = process.env.NODE_ENV === 'production';
  
  if (inProduction && 'serviceWorker' in navigator) {
    const publicUrl = new URL(process.env.PUBLIC_URL, window.location.href);
    if (publicUrl.origin !== window.location.origin) {
      return;
    }

    const swUrl = `${process.env.PUBLIC_URL}/service-worker.js`;

    const doRegister = () => {
      if (isLocalhost) {
        checkValidServiceWorker(swUrl, config);
        navigator.serviceWorker.ready.then(() => {
          console.info('Service worker active in localhost mode');
        });
      } else {
        registerValidSW(swUrl, config);
      }
    };

    // If load already fired (e.g. useEffect runs late), register immediately
    if (document.readyState === 'complete') {
      doRegister();
    } else {
      window.addEventListener('load', doRegister);
    }
  }
}

function registerValidSW(swUrl, config) {
  navigator.serviceWorker
    .register(swUrl)
    .then((registration) => {
      // 1) If there's already a waiting SW, trigger onUpdate immediately
      // Use registration.active instead of navigator.serviceWorker.controller
      // because controller is null after a hard refresh (Ctrl+F5)
      if (registration.waiting && registration.active) {
        if (config && typeof config.onUpdate === 'function') {
          config.onUpdate(registration)
        }
      }

      // 2) Check for updates frequently
      setInterval(() => {
        registration.update()
      }, 1000 * 60)

      registration.onupdatefound = () => {
        const installingWorker = registration.installing
        if (!installingWorker) return

        installingWorker.onstatechange = () => {
          if (installingWorker.state === 'installed') {
            if (registration.active) {
              if (config && typeof config.onUpdate === 'function') {
                config.onUpdate(registration)
              }
            } else {
              if (config && typeof config.onSuccess === 'function') {
                config.onSuccess(registration)
              }
            }
          }
        }
      }
    })
    .catch((error) => {
      console.error('Service worker registration failed:', error)
    })
}

function checkValidServiceWorker(swUrl, config) {
  fetch(swUrl, {
    headers: { 'Service-Worker': 'script' },
  })
    .then((response) => {
      const contentType = response.headers.get('content-type');
      if (
        response.status === 404 ||
        (contentType != null && contentType.indexOf('javascript') === -1)
      ) {
        navigator.serviceWorker.ready.then((registration) => {
          registration.unregister().then(() => {
            window.location.reload();
          });
        });
      } else {
        registerValidSW(swUrl, config);
      }
    })
    .catch(() => {
      console.error('Offline mode - no internet connection');
    });
}

export function unregister() {
  if ('serviceWorker' in navigator) {
    navigator.serviceWorker.ready
      .then((registration) => {
        return registration.unregister();
      })
      .then(() => {
        console.log('Service worker unregistered');
        // Clear all caches
        return caches.keys().then((cacheNames) => {
          return Promise.all(
            cacheNames.map((cacheName) => caches.delete(cacheName))
          );
        });
      })
      .catch((error) => {
        console.error('Unregister error:', error);
      });
  }
}